<ts-page class="w-full" [sidenavConfig]="sideNavConfig">
  <ts-tree-menu
    sidenav
    [suppressHeader]="true"
    [items]="views$ | async"
    [loading]="isLoading"
    [delegateLeafClickFn]="delegateLeafClickFn.bind(this)"
  ></ts-tree-menu>
  @if (view$ | async; as view) {
    <section main class="main">
      <ts-page-header>
        <ng-container page-header-title>
          <section class="list__top__title-wrapper">
            <h5 class="list__top__title">{{ view?.name }}</h5>
          </section>
        </ng-container>
        <ng-container page-header-action-buttons>
          @if (featureSupport$ | async; as featureSupport) {
            <section class="list__bottom__action-buttons">
              @if (featureSupport.homeActions.actions.export) {
                <ts-button
                  denyAction="disable"
                  variant="secondary"
                  icon="ts_file-save"
                  [matTooltip]="LabelSlot.EXPORT_CSV | jupiterLabelSlot: (relatedTo$ | async)"
                  (click)="onExportAsCsv()"
                  [appAuthorize]="PermissionSlot.SHARING_RECORDS | jupiterPermissionSlot"
                >
                  Export
                </ts-button>
              }
              @if (featureSupport.homeActions.actions.add) {
                <ts-button
                  denyAction="disable"
                  variant="primary"
                  icon="add"
                  [matTooltip]="LabelSlot.ADD | jupiterLabelSlot: (relatedTo$ | async)"
                  (click)="onAdd()"
                  [appAuthorize]="PermissionSlot.CREATE | jupiterPermissionSlot"
                  >Add</ts-button
                >
              }
            </section>
          }
        </ng-container>
        <div page-header-action-bar class="w-full">
          <jupiter-action-bar
            [selectedRows]="selectedRows"
            [columns]="displayColumns"
            [filterValueList]="filterValueList | async"
            [fieldDefs]="fieldDefs$ | async"
            [tagsList]="tagsList | async"
            [search]="search | async"
            (columnSelectionChanged)="onColumnSelectionChanged($event)"
            (filterApplied)="onFilterApplied($event)"
            (tagsUpdated)="onTagsUpdated($event)"
            (searchChanged)="onSearchChanged($event)"
            (openTagsBulkUpdate)="onOpenTagsBulkUpdate()"
            (viewActionTriggered)="onViewActionTriggered($event)"
          ></jupiter-action-bar>
        </div>
      </ts-page-header>

      @if (isLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }

      <jupiter-data-table
        [activeSort]="activeSort"
        [data]="data$ | async"
        [columns]="displayColumns"
        [gridActions]="gridActions$ | async"
        (pageChanged)="onPageChanged($event)"
        (cellDataChanged)="onCellDataChanged($event)"
        (rowSelectionChanged)="onRowSelectionChanged($event)"
        (goToDetails)="onGoToDetails($event)"
        (columnMoved)="onColumnMoved($event)"
        (sortChanged)="onSortChanged($event)"
      ></jupiter-data-table>
    </section>
  } @else {
    <!-- placeholder for skeleton -->
  }
</ts-page>
